import React from "react";
import { Alert } from "react-bootstrap";

const ErrorMessage = ({
  error,
  title = "Something went wrong",
  details,
  linkText,
  command,
}) => {
  if (!error) return null;

  return (
    <Alert variant="danger" className="d-flex flex-column align-items-center justify-content-center main-border m-3" >
      <Alert.Heading className="d-flex justify-content-center">{title}</Alert.Heading>
      {typeof error === "string" ? (
        <p>{error}</p>
      ) : (
        <p>{error.message || "An unexpected error occurred."}</p>
      )}

      {details && <hr />}
      {details && <p className="mb-0">{details}</p>}

      {command && (
        <div className="mt-3 d-flex justify-content-center">
        <button onClick={command} className="btn btn-light">
          {linkText || "Go back"}
        </button>
      </div>
      
      )}
    </Alert>
  );
};

export default ErrorMessage;
